import { useContext } from "react";
import { RadarContext, RadarContextType } from "./RadarContextProvider";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import styled from "styled-components/macro";
import { MobileLogo } from "./Logo";
import { iconMenuItems } from "./data/data";
import { Link } from "react-router-dom";
import { EducationIcon } from "./img/EducationIcon";
import { CertificationIcon } from "./img/CertificationIcon";
import { RobotIcon } from "./img/RobotIcon";
import { ExperienceIcon } from "./img/ExperienceIcon";
import { RadarIcon } from "./img/RadarIcon";
import { ArtIcon } from "./img/ArtIcon";
import { StyledTooltip } from "./StyledTooltip";

const drawerWidth = 310;

type DrawerProps = {
  open: boolean;
};

const Drawer = styled(MuiDrawer)<DrawerProps>`
  && {
    background: ${({ theme }) => theme.navBackground};
    flex-shrink: 0;
    white-space: nowrap;
    box-sizing: border-box;
    overflow-x: hidden;
    transition-property: width;
    .MuiDrawer-paper {
      overflow-x: hidden;
      transition: width 0.5s;
      border: none;
      background: ${({ theme }) => theme.navBackground};
      border-radius: 50px;
      max-height: 460px;
      margin: 30px;
      width: ${({ open }) => (open ? drawerWidth : 70)}px;
    }

    a {
      color: ${({ theme }) => theme.sideBarText};
    }
    svg.menu-icon {
      fill: ${({ theme }) => theme.sideBarText} !important;

      stroke: ${({ theme }) => theme.sideBarText} !important;
      path {
        fill: ${({ theme }) => theme.sideBarText} !important;
      }
    }
  }
  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

const renderMenuIcon = (name: string) => {
  switch (name) {
    case "Education":
      return <EducationIcon />;
    case "Certifications":
      return <CertificationIcon />;
    case "Experience":
      return <ExperienceIcon />;
    case "Projects":
      return <ArtIcon />;
    case "Tech Stack":
      return <RadarIcon />;
    default:
      return <RobotIcon />;
  }
};

export default function MiniDrawer({ hide }: { hide?: boolean }) {
  const { setMainMenu } = useContext<RadarContextType>(RadarContext);

  return (
    <>
      <MobileLogo hide={hide} />
      <Drawer anchor={"left"} variant="permanent" open={false}>
        <List>
          <ListItem
            key={"pic"}
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 2,
            }}
          >
            <Link to={"/"}>
              <img
                style={{
                  borderRadius: 100,
                  border: "2px solid white",
                }}
                src={`${process.env.REACT_APP_S3_BASE_URL}me.jpeg`}
                alt={"profile"}
                height={45}
                width={45}
                loading="eager"
              />
            </Link>
          </ListItem>

          {iconMenuItems.map(({ name, url }: any) => (
            <ListItem key={name} disablePadding sx={{ display: "block" }}>
              <Link
                to={`/${url}`}
                onClick={() => {
                  return setMainMenu(name.toLowerCase());
                }}
              >
                <StyledTooltip title={name} placement="right">
                  <ListItemButton
                    sx={{
                      justifyContent: "center",
                    }}
                  >
                    {renderMenuIcon(name)}
                  </ListItemButton>
                </StyledTooltip>
              </Link>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}
